import { Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrentDateContext, CurrentDateContextState } from '../contexts/current-date.context';
import { Subscription } from 'rxjs';
import { CustomUiOptionsContext } from '../contexts/custom-ui-options.context';

@Component({
  selector: 'ziro-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
  private currentDateContext = inject(CurrentDateContext);
  private _translateService = inject(TranslateService);
  private customUiOptionsContext = inject(CustomUiOptionsContext);

  readonly cssClasses = input('bg-light footer py-2 text-center flex-column');

  year: string;
  window = window;
  isLoading = true;
  companyFooterLabel: string;
  showSupportLink = false;

  private _subscriptions = new Subscription();
  private _translationsLoaded = false;

  ngOnInit(): void {
    this._getYear();
    this._loadTranslations();
    this._getUiOptions();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private _getYear(): void {
    const sub = this.currentDateContext.state$.subscribe((state: CurrentDateContextState) => {
      this.year = String(state.year);
      this._updateLoading();
    });
    this._subscriptions.add(sub);
  }

  private _loadTranslations(): void {
    const keys = ['tkey;company.footer'];
    this._translateService.get(keys).subscribe((translations: Record<string, string>) => {
      this.companyFooterLabel = translations['tkey;company.footer'] || 'tkey;company.footer';
      this._translationsLoaded = true;
      this._updateLoading();
    });
  }

  private _getUiOptions(): void {
    const sub = this.customUiOptionsContext.state$.subscribe((uiOptions) => {
      this.showSupportLink = !!uiOptions?.supportTextHtml?.trim();
    });
    this._subscriptions.add(sub);
  }

  private _updateLoading(): void {
    if (this._translationsLoaded && this.year != null) {
      this.isLoading = false;
    }
  }

  protected readonly String = String;
}
